"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _reactDnd = require("react-dnd");

var _DragAndDrop = require("lead-flows-ui/constants/DragAndDrop");

var dragSpec = {
  canDrop: function canDrop(props, monitor) {
    var draggedOptionDisplayOrder = monitor.getItem().displayOrder;
    var targetIndex = props.index;
    var isDraggedOptionDroppedAboveCurrentPosition = draggedOptionDisplayOrder === targetIndex;
    var isDraggedOptionDroppedBelowCurrentPosition = draggedOptionDisplayOrder + 1 === targetIndex;
    return !isDraggedOptionDroppedAboveCurrentPosition && !isDraggedOptionDroppedBelowCurrentPosition;
  },
  drop: function drop(props, monitor, component) {
    if (monitor.didDrop()) {
      return;
    }

    var draggedOptionId = monitor.getItem().id;
    var targetIndex = props.index;
    component.props.handleOptionReorder(draggedOptionId, targetIndex);
  }
};

function collect(connector, monitor) {
  return {
    connectDropTarget: connector.dropTarget(),
    hasDragOver: monitor.isOver(),
    isDragSourceDroppable: monitor.canDrop()
  };
}

var ContactPropertyOptionDropTarget =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(ContactPropertyOptionDropTarget, _React$PureComponent);

  function ContactPropertyOptionDropTarget() {
    (0, _classCallCheck2.default)(this, ContactPropertyOptionDropTarget);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ContactPropertyOptionDropTarget).apply(this, arguments));
  }

  (0, _createClass2.default)(ContactPropertyOptionDropTarget, [{
    key: "hasDragOverClass",
    value: function hasDragOverClass(hasDragOver, isDragSourceDroppable) {
      return hasDragOver && isDragSourceDroppable ? 'form-field-group-drop-target__active' : null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          connectDropTarget = _this$props.connectDropTarget,
          hasDragOver = _this$props.hasDragOver,
          isDragSourceDroppable = _this$props.isDragSourceDroppable;
      var hasDragOverClass = this.hasDragOverClass(hasDragOver, isDragSourceDroppable);
      var className = (0, _classNames.default)('form-field-group-drop-target', hasDragOverClass);
      return connectDropTarget(_react.default.createElement("div", {
        className: className
      }));
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        index: _react.default.PropTypes.number.isRequired,
        handleOptionReorder: _react.default.PropTypes.func.isRequired,
        connectDropTarget: _react.default.PropTypes.func.isRequired,
        hasDragOver: _react.default.PropTypes.bool.isRequired,
        isDragSourceDroppable: _react.default.PropTypes.bool.isRequired
      };
    }
  }]);
  return ContactPropertyOptionDropTarget;
}(_react.default.PureComponent);

var _default = (0, _reactDnd.DropTarget)(_DragAndDrop.DragTypes.CONTACT_PROPERTY_OPTION_SORT, dragSpec, collect)(ContactPropertyOptionDropTarget);

exports.default = _default;
module.exports = exports.default;